import React from 'react';
import PropTypes from 'prop-types';

import {
  canUserModifyBarbers,
  canUserModifyProfile,
  canUserModifySchedules,
} from '../../../../../common/helpers/users';
import { TAB_NAMES } from '../hoc/withTabs';
import { t } from '../../../../../../modules/infra/i18n';

const shouldSubmitBeDisplayed = (props) => {
  const isProfileTabActive = props.tabs && props.tabs[props.activeTab].titleKey === TAB_NAMES.PROFILE;
  const isScheduleTabActive = props.tabs && props.tabs[props.activeTab].titleKey === TAB_NAMES.SCHEDULE;

  return canUserModifyBarbers(props.permissions) && (
    (!isScheduleTabActive && !isProfileTabActive) ||
    (isProfileTabActive && canUserModifyProfile(props.permissions)) ||
    (isScheduleTabActive && canUserModifySchedules(props.permissions))
  );
};

const SaveButton = props => {
  // Store translation key instead of calling t() at module level
  const defaultText = props.text || t('barber:brand_barber.save.button'); // ✅ t() called at runtime
  
  return (
    <button
      display-if={shouldSubmitBeDisplayed(props)}
      disabled={props.submitting}
      type="submit"
      className="c-btn pointer-events u-min-width-125"
    >
      <span className="c-btn__text">{defaultText}</span>
    </button>
  );
};

SaveButton.propTypes = {
  submitting: PropTypes.bool,
  text: PropTypes.string,
  activeTab: PropTypes.number.isRequired, // eslint-disable-line react/no-unused-prop-types
  permissions: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
};

SaveButton.defaultProps = {
  submitting: false,
};

export default SaveButton;
